module.exports = __webpack_public_path__ + "img/cylinder.c5d9f25d.png";